import { render, staticRenderFns } from "./PackageMaker.vue?vue&type=template&id=07c5b3dc"
import script from "./PackageMaker.vue?vue&type=script&lang=js"
export * from "./PackageMaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports